module.exports = __webpack_public_path__ + "97a1e34fbf4733d432d2cd1e9d916d88.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-jormat.png
// module id = 107
// module chunks = 0